export type TMimeType = "text/plain" | "image/png" | "image/jpeg";

export const blobFromResponseBytes = async (resp: Response) => {
  return await resp.blob();
};

export const blobFromByteArray = (
  byteArray: Uint8Array | number[] | string,
  logPrefix: string,
  mimeType?: TMimeType,
): Blob | null => {
  // Convert byte array to Uint8Array if it's not already
  let uint8Array: Uint8Array;

  // Check if it's a Base64 string
  if (typeof byteArray === "string") {
    try {
      const normalizedBase64 = byteArray.trim();
      const isBase64 =
        normalizedBase64.length > 0 &&
        normalizedBase64.length % 4 === 0 &&
        /^[A-Za-z0-9+/]+={0,2}$/.test(normalizedBase64);

      if (isBase64) {
        // Decode Base64 string to binary
        const binaryString = atob(normalizedBase64);
        uint8Array = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          uint8Array[i] = binaryString.charCodeAt(i);
        }
      } else {
        // Treat plain text payloads as UTF-8 so translation results that are not base64 still render correctly
        uint8Array = new TextEncoder().encode(byteArray);
      }
    } catch (error) {
      console.error(`${logPrefix} Failed to decode Base64 string:`, error);
      return null;
    }
  } else if (byteArray instanceof Uint8Array) {
    uint8Array = byteArray;
  } else if (Array.isArray(byteArray)) {
    uint8Array = new Uint8Array(byteArray);
  } else {
    console.error(
      `${logPrefix} Expected result to be a string or byte array, but was a `,
      typeof byteArray,
      "\n",
      byteArray,
    );
    return null;
  }

  const blob = new Blob([uint8Array as any], { type: mimeType ?? "text/plain" });
  return blob;
};
